import { createAsyncAction } from 'react-redux-await-control';
import { message } from 'antd';

import { telli } from '~/services';
import { handleErrors } from '~/common/utils/errorHandler';

export const login = createAsyncAction('LOGIN', {
  context: {
    beforeRequest: () => {
      localStorage.removeItem('authenticationToken');
      localStorage.removeItem('authMethod');
    },
    request: (data) => telli.post('/logintoken', data, { headers: {} }),
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Falha ao tentar realizar login.' }),
  },
});

export const googleLogin = createAsyncAction('GOOGLE_LOGIN', {
  context: {
    request: ({ token, redirectUri, keepToken, codeVerifier }) => {
      if (!keepToken) {
        localStorage.removeItem('authenticationToken');
        localStorage.removeItem('authMethod');
      }
      // codeVerifier (PKCE) vai quando o login foi iniciado com code_challenge; o telli exige o
      // verifier na troca quando google.pkce.required esta ligado.
      const body = codeVerifier ? { token, redirectUri, codeVerifier } : { token, redirectUri };
      return telli.post('/login-google-token', body, { headers: {} });
    },
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Falha ao tentar realizar o login.' }),
  },
});

export const refreshLogin = createAsyncAction('REFRESH_LOGIN', {
  context: {
    request: () => telli.get('/refresh-token'),
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Falha ao tentar realizar a renovação da sessão.' }),
  },
});

export const getLoggedUser = createAsyncAction('GET_LOGGED_USER', {
  initialValue: {},
  saveResult: true,
  context: {
    request: () => telli.get('/admin/usercustom/loggeduser'),
  },
});

export const getSessionToken = createAsyncAction('GET_SESSION_TOKEN');

export const logout = createAsyncAction('LOGOUT');

export const fetchUsers = createAsyncAction('USERS_FETCH_REQUEST', {
  initialValue: [],
  saveResult: true,
  context: {
    request: () => telli.get('/admin/usercustom/users'),
  },
});

export const createUser = createAsyncAction('CREATE_USER', {
  context: {
    request: (data) => telli.post('/admin/usercustom/createuserbackoffice', data),
    onRequestSuccess: () => message.success('Usuário criado com sucesso'),
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Falha ao tentar criar usuário' }),
  },
});
